"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var core_components_1 = require("@securityproducts/core-components");
var archiveDateRange_styles_1 = require("./archiveDateRange.styles");
var dateAndTime_1 = require("../custom-date-range/dateAndTime");
var archiveDateRange_i18n_1 = require("./archiveDateRange.i18n");
function ArchiveDateRange(props) {
    var _a = React.useState(props.from), from = _a[0], setFrom = _a[1];
    var _b = React.useState(props.to), to = _b[0], setTo = _b[1];
    var strings = core_components_1.useLocalisation(archiveDateRange_i18n_1.archiveDateRangeTranslations, props.language);
    function applyRange() {
        props.setArchiveMode(true);
        props.setRange({
            fromDate: from.set({ day: 1, hour: 0, minute: 0, second: 0, millisecond: 0 }),
            toDate: to
                .set({
                month: to.month + 1,
                day: 1,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
            })
                .minus({ minutes: 1 }),
        });
        props.setDisplay("MONTHS");
        props.setCurrentRange("Archived");
        setTimeout(function () { return props.closePicker(); }, 0);
    }
    function reset() {
        setFrom(props.from);
        setTo(props.to);
    }
    function cancel() {
        reset();
        props.closePicker();
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: archiveDateRange_styles_1.row },
            React.createElement(dateAndTime_1.DateAndTime, { id: "start-date", label: strings.startDate, value: from, setDate: setFrom, enableTime: false, archiveMode: true, archiveDataFrom: props.archiveDataFrom, callSummaryDataFrom: props.callSummaryDataFrom, language: props.language }),
            React.createElement(dateAndTime_1.DateAndTime, { id: "end-date", label: strings.endDate, value: to, setDate: setTo, enableTime: false, archiveMode: true, archiveDataFrom: props.archiveDataFrom, callSummaryDataFrom: props.callSummaryDataFrom, language: props.language })),
        React.createElement("div", { className: archiveDateRange_styles_1.buttonRow },
            React.createElement(core_components_1.Button, { className: archiveDateRange_styles_1.applyButton, id: "apply-custom-date", onClick: applyRange }, strings.apply),
            React.createElement(core_components_1.Button, { className: archiveDateRange_styles_1.cancelButton, id: "cancel-custom-date", text: true, onClick: cancel }, strings.cancel))));
}
exports.ArchiveDateRange = ArchiveDateRange;
